import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

import { LastIncidentsConfig } from '../../../configuration'
import { incidentsUpdate } from '../../configuration'

const incidentsToTrackUpdate = new Set([RugbyUnionIncidentId.EntryInto22])

export const lastIncidentsConfig: LastIncidentsConfig = {
  incidentsUpdate: (...args) =>
    incidentsUpdate(...args, incidentsToTrackUpdate),
}
